import { Slider } from '@mui/material'
import styled from 'styled-components'

export const AudioPipContainer = styled.div`
  position: fixed;
  z-index: 1000;
  bottom: 0px;
  height: 90px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px -27px 60px rgba(0, 0, 0, 0.51);
  backdrop-filter: blur(8px);
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  padding-right: 20px;
  @media (min-width: 800px) {
    padding-right: 80px;
  }
  @media (min-width: 1300px) {
    padding-right: 120px;
  }
`

export const StyledSliderContainer = styled.div`
  width: 40%;
  color: white;
  margin-right: 20px;
  @media (min-width: 800px) {
    margin-right: 60px;
  }
  @media (min-width: 1300px) {
    margin-right: 120px;
  }
`

export const PrettoSlider = styled(Slider)`
  height: 5px !important;
  & .MuiSlider-track {
    border: 'none';
    height: 6px;
    background-color: #706bca;
  }
  & .MuiSlider-rail {
    height: 6px;
    background: #9a9a9a;
  }
  & .MuiSlider-thumb {
    height: 15px;
    width: 15px;
    background: #ffffff;
  }
  ,
  & .MuiSlider-mark {
    width: 5px;
    height: 18px;
    border-radius: 7px;
    margin-top: -6px;
  }
`

export const StyledPlayPauseButton = styled.img`
  height: 40px;
  width: 40px;
  &:hover {
    cursor: pointer;
  }
`

export const StyledForwardButton = styled.img`
  height: 25px;
  width: 25px;
  &:hover {
    cursor: pointer;
  }
`

export const StyledPlayControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 450px;
  height: 93px;
  gap: 10px;
  @media (min-width: 800px) {
    gap: 20px;
  }
  @media (min-width: 1300px) {
    gap: 30px;
  }
`

export const StyledHeaderButton = styled.img`
  z-index: 10000;
  height: 30px;
  width: 30px;
  &:hover {
    cursor: pointer;
  }
`

export const StyledSessionIcon = styled.div`
  width: 60px;
  height: 60px;
  background-image: url(${(props) => props.imgURL});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-color: #ffffff;
  border-width: 2px;
  border-radius: 14px;
  margin-right: 16px;
  flex-shrink: 0;
  @media (max-width: 550px) {
    display: none;
  }
`
export const StyledSessionTitle = styled.div`
  font-family: Outfit;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: 0.02em;
  color: #ffffff;
`

export const StyledSessionSubTitle = styled.div`
  font-family: Outfit;
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #ffffff;
`

export const StyledSessionItemDetail = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  margin-left: 15px;
  @media (min-width: 800px) {
    margin-left: 30px;
  }
  @media (min-width: 1300px) {
    margin-left: 60px;
  }
  &:hover {
    cursor: pointer;
  }
`
